import { Typography } from "@mui/material";
import { Box } from "@mui/system";
import { observer } from "mobx-react-lite";

export const MixQuickBrandText = observer(function MixQuickBrandText({
  disableFullText,
  sx,
  ...props
}) {
  return (
    <Box>
      <Typography
        {...props}
        sx={(theme) => ({
          fontFamily: "PermanentMarker",
          fontSize: 28,
          lineHeight: "36px",
          WebkitTextStroke: 1,

          WebkitTapHighlightColor: "transparent",
          cursor: "pointer",
          WebkitTextStrokeColor: theme.palette.altPrimary.main,
          color: "black",
          ...sx,
        })}
      >
        Mix.Quick
      </Typography>
    </Box>
  );
});

export default MixQuickBrandText;
